module.exports = __webpack_public_path__ + "resource/img/record.png?093bd1419b367cf6f5324f07b9abdd31";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/record.png
// module id = 655
// module chunks = 0 2